<template>
  <div class="scroll-pane-wrapper">
    <div
      v-show="isOverflow && canScrollLeft"
      class="scroll-arrow scroll-arrow-left"
      @click="scrollByStep('left')"
    >
      <i class="el-icon-arrow-left"></i>
    </div>
    <el-scrollbar
      ref="scrollContainer"
      :vertical="false"
      class="scroll-container"
      @wheel.native.prevent="handleScroll"
    >
      <slot />
    </el-scrollbar>
    <div
      v-show="isOverflow && canScrollRight"
      class="scroll-arrow scroll-arrow-right"
      @click="scrollByStep('right')"
    >
      <i class="el-icon-arrow-right"></i>
    </div>
  </div>
</template>

<script>
const tagAndTagSpacing = 4 // tagAndTagSpacing

export default {
  name: 'ScrollPane',
  data() {
    return {
      left: 0,
      isOverflow: false,
      canScrollLeft: false,
      canScrollRight: false,
    }
  },
  computed: {
    scrollWrapper() {
      return this.$refs.scrollContainer.$refs.wrap
    },
  },
  mounted() {
    this.scrollWrapper.addEventListener('scroll', this.emitScroll, true)
    this.updateScrollState()
    // 监听容器与内容尺寸变化（tab 增减、窗口缩放）
    this.resizeObserver = new ResizeObserver(() => {
      this.updateScrollState()
    })
    this.resizeObserver.observe(this.scrollWrapper)
    if (this.scrollWrapper.children[0]) {
      this.resizeObserver.observe(this.scrollWrapper.children[0])
    }
  },
  beforeDestroy() {
    this.scrollWrapper.removeEventListener('scroll', this.emitScroll)
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  },
  methods: {
    handleScroll(e) {
      const eventDelta = e.wheelDelta || -e.deltaY * 40
      const $scrollWrapper = this.scrollWrapper
      $scrollWrapper.scrollLeft = $scrollWrapper.scrollLeft + eventDelta / 4
      this.updateScrollState()
    },
    emitScroll() {
      this.$emit('scroll')
      this.updateScrollState()
    },
    updateScrollState() {
      const $scrollWrapper = this.scrollWrapper
      if (!$scrollWrapper) return
      const scrollWidth = $scrollWrapper.scrollWidth
      const clientWidth = $scrollWrapper.clientWidth
      const scrollLeft = $scrollWrapper.scrollLeft
      this.isOverflow = scrollWidth - clientWidth > 1
      this.canScrollLeft = scrollLeft > 1
      this.canScrollRight = scrollLeft < scrollWidth - clientWidth - 1
    },
    scrollByStep(direction) {
      const $scrollWrapper = this.scrollWrapper
      const step = $scrollWrapper.clientWidth * 0.8
      const targetLeft = direction === 'left'
        ? $scrollWrapper.scrollLeft - step
        : $scrollWrapper.scrollLeft + step
      // 平滑滚动
      if ($scrollWrapper.scrollTo) {
        $scrollWrapper.scrollTo({ left: targetLeft, behavior: 'smooth' })
      } else {
        $scrollWrapper.scrollLeft = targetLeft
      }
      this.updateScrollState()
    },
    moveToTarget(currentTag) {
      const $container = this.$refs.scrollContainer.$el
      const $containerWidth = $container.offsetWidth
      const $scrollWrapper = this.scrollWrapper
      const tagList = this.$parent.$refs.tag

      let firstTag = null
      let lastTag = null

      // find first tag and last tag
      if (tagList.length > 0) {
        firstTag = tagList[0]
        lastTag = tagList[tagList.length - 1]
      }

      if (firstTag === currentTag) {
        $scrollWrapper.scrollLeft = 0
      } else if (lastTag === currentTag) {
        $scrollWrapper.scrollLeft = $scrollWrapper.scrollWidth - $containerWidth
      } else {
        // find preTag and nextTag
        const currentIndex = tagList.findIndex((item) => item === currentTag)
        const prevTag = tagList[currentIndex - 1]
        const nextTag = tagList[currentIndex + 1]

        // the tag's offsetLeft after of nextTag
        const afterNextTagOffsetLeft =
          nextTag.$el.offsetLeft + nextTag.$el.offsetWidth + tagAndTagSpacing

        // the tag's offsetLeft before of prevTag
        const beforePrevTagOffsetLeft =
          prevTag.$el.offsetLeft - tagAndTagSpacing

        if (
          afterNextTagOffsetLeft >
          $scrollWrapper.scrollLeft + $containerWidth
        ) {
          $scrollWrapper.scrollLeft = afterNextTagOffsetLeft - $containerWidth
        } else if (beforePrevTagOffsetLeft < $scrollWrapper.scrollLeft) {
          $scrollWrapper.scrollLeft = beforePrevTagOffsetLeft
        }
      }
      this.updateScrollState()
    },
  },
}
</script>

<style lang="scss" scoped>
.scroll-pane-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
}
.scroll-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 100%;
  cursor: pointer;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.18);
  flex-shrink: 0;
  z-index: 10;
  transition: background 0.2s;
  user-select: none;
  &:hover {
    background: rgba(0, 0, 0, 0.32);
  }
  i {
    font-size: 15px;
    font-weight: bold;
  }
}
.scroll-container {
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  flex: 1;
  min-width: 0;
  height: 100%;
  ::v-deep {
    .el-scrollbar__bar {
      bottom: 0px;
      height:0
    }
    .el-scrollbar__wrap ::-webkit-scrollbar {
      display: none;
    }
  }
  ::v-deep.el-scrollbar__view{
    width: 100%;
    height: 50px;
    padding: 5px;
    box-sizing: border-box;
  }
}
</style>
